import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { EntitlementGate } from '@/components/gates';
import { RunsList } from '@/components/scout';

export const Route = createFileRoute('/scout/runs/')({
  component: ScoutRunsPage,
});

function ScoutRunsPage() {
  const navigate = useNavigate();
  return (
    <EntitlementGate module="scout">
      <div className="space-y-6">
        <PageHeader
          title="Run Status"
          action={{ label: 'Export', onClick: () => navigate({ to: '/scout/export' }) }}
        />
        <RunsList />
      </div>
    </EntitlementGate>
  );
}
